import { css } from '@/styled-system/css';

// A bordered mini-capsule so the lead counter reads as its own control rather than a third arrow
// next to the prev/next chevrons.
export const leadJumpTriggerStyles = css.raw({
  height: '28px',
  borderRadius: 'pill',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.muted',
  paddingInline: 'tighter',
  _hover: { backgroundColor: 'bg.softest' },
});

export const leadJumpTriggerContentStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
});

export const leadJumpMenuGroupStyles = css.raw({
  fontFamily: 'sansSerif',
  maxHeight: '320px',
  overflowY: 'auto',
});
